import detail_dosha_map_sp from './detail/detail_dosha_map_sp';
import detail_uryo_map from './detail/detail_uryo_map';
import util from './util';
import detail_snake from './detail/detail_snake';
import uryoPointNameTable from './table/uryoPointNameTable';
import uryoDetail from './uryoDetail';
//  CSSのみで
//  スネーク図のレイアウト調整方法を発見できなかった為
//  一部サイズ調整をResizeイベントにて行う
function setLayout() {
    let el = $('#detail_snake_graph');
    let width = el.width();
    if (width) {
        el.height(width * 0.85);
    }
}
window.onload = () => {
    comMain(() => {
        setTimeout(() => {
            let detail = new uryoDetail_sp();
            detail.Initilize();
            initPage(GM_ID_SP_URYO_DETAIL_GRAPH);
            setLayout();
            window.addEventListener("resize", () => { setLayout(); });
            // 生成したインスタンスをグローバル変数に保存
            window.uryoDetailInstance = detail;
        }, 10);
    });
};
/**
 * 雨量詳細画面（４画面表示）
 */
export default class uryoDetail_sp extends uryoDetail {
    _doshaMapSp = null;
    _uryoPointNameTable = new uryoPointNameTable();
    /**
     * コンストラクタ
     */
    constructor() {
        super();
    }
    /**
     * 初期化処理
     */
    Initilize() {
        util.isSp = true;
        const self = this;
        const uryoGeoJson = util.getGeoJson(util.getPath(dosya_1kmesh_env.uryoGeoJson));
        //  雨量計測地点テーブル作成
        this._uryoPointTable = this.createUryoPointTable(uryoGeoJson);
        //  地図の表示位置取得
        let mapPos = this.getMapPos();
        //  ヘッドラインの表示
        this.setHeadline(mapPos);
        //  地図及びスネーク図の表示タイミングを少しずらす
        setTimeout(() => {
            //  雨量地図
            self._uryoMap = new detail_uryo_map(mapPos, (uryoPiont) => { self.onUryoPointClick(uryoPiont); }, true, "detail_uryo_map");
            self._doshaMapSp = new detail_dosha_map_sp(mapPos, (meshcode) => { self.onMeshClick(meshcode); }, "detail_dosha_map");
            //  レイヤ描画
            if (mapPos.uryo_point) {
                self._uryoMap.setMaker(this.getUryoPointLatLng(mapPos.uryo_point));
            }
            self._doshaMapSp.dispMeshLayer();
            self._doshaMapSp.selectMesh(mapPos.mesh_code);
            if (mapPos.mesh_code) {
                self._snakeGraph = new detail_snake(mapPos.mesh_code, true);
            }
            //  地図表示のリンク設定
            this.setLinkMap();
            // 雨量レイヤー初期化
            self.checkUryoLayer();
            //  一定間隔でデータの更新チェックを行う
            self.setUpdateCheckInterval();
            // 雨量詳細画面サブスクリプト（uryoDetailSub_sp.js）初期化
            uryoDetailSubInit(GM_ID_SP_URYO_DETAIL_GRAPH, mapPos.uryo_point);
        }, 10);
    }
    /**
     * ヘッドラインに整備事務所名を表示
     * @param mapPos
     */
    setHeadline(mapPos) {
        let rec = this._uryoPointNameTable.getInfo(mapPos.uryo_point);
        // ヘッダーに整備事務所名表示
        var shinkokyoku = getShinkokyoku(rec.scd);
        $('#shinkokyoku').text(shinkokyoku.name);
        $('#obName').text(rec.ccdName);
        $('#obNameKana').text(rec.ccdNameKana);
        $('#obAddress').text(rec.ccdAddress);
        // 戻るリンクの設定
        let prevUrl = document.referrer;
        let backUrl = "";
        if (-1 < prevUrl.indexOf('top.html')) {
            //  TOP画面から遷移した場合、TOP画面に戻る
            backUrl = prevUrl;
        }
        else {
            //  その他から遷移した場合
            if (-1 < prevUrl.indexOf('scd')) {
                //  クエリストリングにSCDが指定されていた場合は、指定されたscdを指定して戻る
                backUrl = "uryoList.html?scd=" + prevUrl.slice(prevUrl.indexOf('=') + 1);
            }
            else {
                //  未指定の場合は、現在表示している雨量計測地点の整備事務所のリストに戻る
                $('#back').attr('href', "uryoList.html?scd=" + rec.scd);
            }
        }
        $('#back').attr('href', backUrl);
        // グラフボタンURL設定
        $('#tableBtn').attr('href', `uryoDetailTable.html?scd=${rec.scd}&ccd=${rec.ccd}`);
    }
    /**
     * 地図表示位置の変更
     * @param latlng
     */
    setView(mapPos) {
        this.setHeadline(mapPos);
        //  雨量計測地点地図
        if (this._uryoMap) {
            if (mapPos.uryo_point) {
                this._uryoMap.setMaker(this.getUryoPointLatLng(mapPos.uryo_point));
            }
            this._uryoMap.Map.setView(mapPos.center, mapPos.zoom);
        }
        //  土砂災害メッシュ
        if (this._doshaMapSp) {
            if (mapPos.mesh_code) {
                this._doshaMapSp.selectMesh(mapPos.mesh_code);
            }
            this._doshaMapSp.Map.setView(mapPos.center, mapPos.zoom);
        }
        //  スネーク図
        if (this._snakeGraph && mapPos.mesh_code) {
            this._snakeGraph.dispGraph(mapPos.mesh_code);
        }
        // // 雨量詳細画面サブスクリプト（uryoDetailSub.js）に通知
        if (mapPos.uryo_point) {
            onChageUryoPoint(mapPos.uryo_point);
        }
    }
}
